import { memo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-solid-svg-icons/faAngleDoubleRight';

import Styles from './styles.module.scss';

import { DIRECTORIES_PATH } from '../../data/directory/constants';
import withComponentName from '../../decorators/withComponentName';

function Breadcrumbs({ items, base, className }) {
  return (
    <nav className={`${Styles.navbar} ${className}`.trim()}>
      {items.map(({
        name,
        path,
        onClick,
        className,
        style,
      }, index, arr) => (
        <Fragment key={name}>
          <Link className={className || ''} style={style} to={path ? `${base}/${path}` : `${base}`} onClick={onClick || null}>
            {name}
          </Link>
          {index !== arr.length - 1 && <FontAwesomeIcon icon={faAngleDoubleRight} />}
        </Fragment>
      ))}
    </nav>
  );
}

export default withComponentName(memo(Breadcrumbs));

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    path: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
  })),
  base: PropTypes.string,
  className: PropTypes.string,
};

Breadcrumbs.defaultProps = {
  items: [],
  base: DIRECTORIES_PATH,
  className: '',
};
